import { yupResolver } from '@hookform/resolvers/yup';
import { ChevronLeftIcon, EnterIcon } from '@radix-ui/react-icons';
import { Button, Card, Flex, Spinner } from '@radix-ui/themes';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { useMutation, useQueryClient } from 'react-query';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import RadioGroupComponent from '../../components/inputs/RadioGroup/RadioGroupComponent';
import TextFieldComponent from '../../components/inputs/Textfield/TextfieldComponent';
import { useAppDispatch } from '../../hooks/hooks';
import { resetUpdateEnrollmentRequiredDocumentData } from '../../redux/slices/school/enrollmentRequiredDocument';
import { RootState } from '../../redux/store';
import { routes } from '../../routes';
import { updateEnrollmentRequiredDocument } from '../../services/school/enrollmentRequiredDocument/updateEnrollmentRequiredDocument';
import { EnrollmentRequiredDocumentType } from '../../types/EnrollmentRequiredDocument';
import { CourseLevels, Regimes } from '../../utils/codes';
import { Key_enrollmentRequiredDocuments } from '../../utils/constants';
import { UpdateEnrollmentRequiredDocumentFormValidation } from './UpdateEnrollmentRequiredDocumentFormValidation';

export default function UpdateEnrollmentRequiredDocument() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const mutation = useMutation({ mutationFn: updateEnrollmentRequiredDocument, mutationKey: "updateEnrollmentRequiredDocument" })
  const UpdateFormData = useSelector((state: RootState) => state.enrollmentRequiredDocument);
  const queryClient = useQueryClient();

  const { control, handleSubmit, formState: { errors } } = useForm<EnrollmentRequiredDocumentType>({
    resolver: yupResolver(UpdateEnrollmentRequiredDocumentFormValidation),
    defaultValues: UpdateFormData,
    mode: 'onBlur',
    reValidateMode: 'onBlur',
    shouldUseNativeValidation: false,
  })
  const onSubmit = handleSubmit(async (data) => {
    try {

      if( data.regime == 0 ) {
        delete data.regime;
      }
      
      const result = await mutation.mutateAsync(data);
      if (result) {
        toast.success('Tipo de documento actualizado');
        queryClient.invalidateQueries(Key_enrollmentRequiredDocuments);
        navigate(routes.enrollmentrequireddocuments);
      }
    } catch (err: any) {
      toast.error(`${mutation.error ?? err?.message}`);
    }
  });
  const handleBack = (e: any) => {
    dispatch(resetUpdateEnrollmentRequiredDocumentData());
    navigate(routes.enrollmentrequireddocuments);
  }
  return (

    <form onSubmit={onSubmit} noValidate>
      <Card size='1'>
        <Flex direction='column' gap='4'>

          <TextFieldComponent control={control} errors={errors} label='Tipo de documento' name='description' required={true} />

          <Flex gap="8">
            <RadioGroupComponent name="level" label="Nivel" control={control} errors={errors} style={{ width: '100%' }}
              options={CourseLevels.map(cl => ({
                value: cl.id ?? "",
                label: cl.description ?? ""
              }))}
              fieldProps={{
                style: { display: 'flex', flexDirection: 'row', gap: 'var(--space-4)' }
              }}
            />
          </Flex>

          <Flex gap="8">
            <RadioGroupComponent name="regime" label="Regime" control={control} errors={errors} style={{ width: '100%' }}
              options={Regimes.map(reg => ({
                value: reg.id ?? "",
                label: reg.description ?? ""
              }))}
              fieldProps={{
                style: { display: 'flex', flexDirection: 'row', gap: 'var(--space-4)' }
              }}
            />
          </Flex>

          <Flex direction='row' gap='4' style={{ alignSelf: 'end' }}>
            <Button type="button" variant="soft" color="gray" onClick={handleBack} disabled={mutation.isLoading}>
              <ChevronLeftIcon /> Voltar
            </Button>
            <Button type="submit" disabled={mutation.isLoading} variant='surface'  >
              {mutation.isLoading ? <Spinner loading> <EnterIcon /></Spinner> : <EnterIcon />}
              Registar
            </Button>
          </Flex>
        </Flex>
      </Card>
    </form>
  );
}